import { computed } from 'vue';

import {
  CLIENT_LOGIN_USER_TYPE,
  LoginStatus,
  userTypeMap,
} from '@/services/tracking/GtmTrackingService';
import { useUserStore } from '@/stores/user';
import { UserGroup } from '@/types';

export function useTrackingUserType() {
  const userStore = useUserStore();

  const trackingUserType = computed(() => {
    if (userStore.loginStatus === LoginStatus.NOT_LOGGED_IN) {
      return CLIENT_LOGIN_USER_TYPE.PPA_GUEST;
    }

    if (userStore.userGroups.includes(UserGroup.CUSTOMER_SERVICE_AGENT)) {
      return CLIENT_LOGIN_USER_TYPE.PPA_CCC;
    }

    return userTypeMap[userStore.userType] ?? CLIENT_LOGIN_USER_TYPE.PPA_PRIVATE;
  });

  return { trackingUserType };
}
